import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col } from 'shared/components'

import * as styles from './styles'

const DeleteButtonComponent = ({
  value: event,
  onDeleteBeneficiariesBankAccountByIban,
}) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          title="Remove bank account"
          disabled={event.resolved}
          onClick={onDeleteBeneficiariesBankAccountByIban}
        >
          <FontAwesomeIcon size="lg" icon="trash" css={styles.icon} />
        </Button>
      </Col>
    </Row>
  </Grid>
)

DeleteButtonComponent.propTypes = {
  value: PropTypes.shape(),
  onDeleteBeneficiariesBankAccountByIban: PropTypes.func.isRequired,
}

export default DeleteButtonComponent
